import { Component, ChangeDetectionStrategy } from '@angular/core';
import quickFadeIn from 'src/app/shared/animations/quick-fadeIn.animation';
@Component({
    selector: 'ups-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [quickFadeIn],
    standalone: false
})
export class MainLayoutComponent {
  constructor() {}
}
